import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-template-rsvn',
  templateUrl: './template-rsvn.component.html',
  styleUrls: ['./template-rsvn.component.scss']
})
export class TemplateRsvnComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
